import { useEffect, useState } from 'react'
import { supabase } from '@lib/supabase'
import type { Tables } from './types/database'

type Section = Tables<'sections'>

function App() {
  const [sections, setSections] = useState<Section[]>([])
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function fetchSections() {
      try {
        const { data, error } = await supabase
          .from('sections')
          .select('*')
          .order('display_order')

        if (error) throw error
        setSections(data ?? [])
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Unknown error')
      } finally {
        setLoading(false)
      }
    }

    void fetchSections()
  }, [])

  return (
    <div style={{ padding: '2rem', fontFamily: 'system-ui' }}>
      <h1>UCAT Portal</h1>
      <h2>Infrastructure Check</h2>

      {loading && <p>Loading sections...</p>}

      {error && (
        <div style={{ color: 'red', padding: '1rem', background: '#fee' }}>
          <strong>Error:</strong> {error}
        </div>
      )}

      {!loading && !error && sections.length > 0 && (
        <div style={{ color: 'green', padding: '1rem', background: '#efe' }}>
          <strong>Success!</strong> Connected to Supabase
          <ul>
            {sections.map((s) => (
              <li key={s.id}>
                {s.short_name}: {s.name} ({s.question_count} questions, {s.time_limit_seconds}s)
              </li>
            ))}
          </ul>
        </div>
      )}

      {!loading && !error && sections.length === 0 && (
        <div style={{ color: 'orange', padding: '1rem', background: '#ffe' }}>
          <strong>Warning:</strong> Connected but no sections found. Run seed.
        </div>
      )}
    </div>
  )
}

export default App
